// extracted by mini-css-extract-plugin
module.exports = {"WeekForecast":"styles_WeekForecast__3si05","heading":"styles_heading__30xAF","itemsWrapper":"styles_itemsWrapper__1ypZT"};